import React from 'react';
import shortid from 'shortid';
import Icons from 'components/icons';
import styles from './actions.module.scss';

const Actions = ({ data = [] }) => (
  <div className={styles.actions}>
    <ul>
      {data.map(({ name, title, onClick }) => (
        <li key={shortid.generate()}>
          <a title={title} onClick={onClick} onKeyDown={() => {}}>
            <Icons name={name} />
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Actions;
